import React, {useContext} from 'react';
import {withTranslation} from 'react-i18next';

import {NavMenuDivider, NavMenuItem} from 'components/NavMenu';

import {WebAppInstallPromptContext} from '../../webAppInstallPrompt/context';

function AddToHomeScreen({t}) {
	const {capturedPrompt, promptUser} = useContext(WebAppInstallPromptContext);

	if (!capturedPrompt) return null;

	return (
		<>
			<NavMenuDivider />
			<NavMenuItem id="a2hs_button" onClick={promptUser}>
				{t('actions_add_to_homescreen')}
			</NavMenuItem>
		</>
	);
}

export default withTranslation()(AddToHomeScreen);
